var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"color":"error","loading":_vm.loading,"outlined":""},on:{"click":_vm.confirmDelete}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-delete")]),_vm._t("default",function(){return [_vm._v("Eliminar")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }